import axios from 'axios';

class RESTService {
    // GET request
    get = async (url) => {
        const response = await axios.get(url, {
            headers: {
                'Accept': 'application/json',
            },
            withCredentials: true
        });
        return response.data;  // Return only the data part of the response
    }

    // POST request
    post = async (url, body, headers = {}) => {
        const response = await axios.post(url, body, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                ...headers
            },
            withCredentials: true,
        });
        
        return response.data;
    }

    // POST request — returns { data, headers } so callers can inspect response headers
    postRaw = async (url, body, headers = {}) => {
        const response = await axios.post(url, body, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                ...headers
            },
            withCredentials: true,
        });
        return { data: response.data, headers: response.headers };
    }

    // PUT request
    put = async (url, body, headers = {}) => {
        const response = await axios.put(url, body, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                ...headers
            },
            withCredentials: true
        });
        return response.data;
    }

    // DELETE request
    delete = async (url, body = null) => {
        const response = await axios.delete(url, {
            headers: {
                'Accept': 'application/json',
                ...(body !== null && { 'Content-Type': 'application/json' }),
            },
            withCredentials: true,
            ...(body !== null && { data: body }),
        });
        return response.data;
    }
}

export const restService = new RESTService();
